const ENDPOINT = '/api/v1/pwa_performance_events';

let queue = [];
let lifecycleArmed = false;

// source: 'pwa_page' | 'service_worker' | 'offline_sync'
// eventName: one of the closed PwaPerformanceEvent event names
// options: { metricName, value, unit, httpStatus, online, displayMode,
//            serviceWorkerControlled, path, referrerPath, metadata }
export function recordPwaMetric(source, eventName, options = {}) {
  queue.push(buildEvent(source, eventName, options));
}

function buildEvent(source, eventName, options) {
  const event = {
    source,
    event_name: eventName,
    occurred_at: new Date().toISOString(),
    metric_name: options.metricName,
    value: options.value,
    unit: options.unit,
    http_status: options.httpStatus,
    display_mode: options.displayMode ?? detectDisplayMode(),
    service_worker_controlled: options.serviceWorkerControlled ?? detectServiceWorkerControlled(),
    online: options.online ?? navigator.onLine,
    path: options.path ?? window.location?.pathname,
    referrer_path: options.referrerPath,
    metadata: options.metadata
  };

  Object.keys(event).forEach((key) => event[key] === undefined && delete event[key]);
  return event;
}

function detectDisplayMode() {
  const modes = ['standalone', 'minimal-ui', 'fullscreen', 'browser'];
  const match = modes.find((mode) => window.matchMedia?.(`(display-mode: ${mode})`)?.matches);
  if (match) return match.replace('-', '_');
  return window.navigator?.standalone ? 'ios_standalone' : 'unknown';
}

function detectServiceWorkerControlled() {
  if (!navigator.serviceWorker) return undefined;
  return Boolean(navigator.serviceWorker.controller);
}

export function flushPerformanceMetrics() {
  if (queue.length === 0) return;
  const body = JSON.stringify({ events: queue });
  queue = [];

  if (typeof navigator.sendBeacon === 'function') {
    navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
    return;
  }

  fetch(ENDPOINT, {
    method: 'POST',
    keepalive: true,
    headers: { 'Content-Type': 'application/json' },
    body
  });
}

export function bootPerformanceMetrics() {
  if (lifecycleArmed) return;
  lifecycleArmed = true;
  window.addEventListener('pagehide', flushPerformanceMetrics);
}
